import { useState } from 'react';
import { supabase } from '../../supabaseClient';

const IconShare = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--lavender)' }}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

export default function ModalCompartilhar({ nota, desafioAtivo, prompt, onFechar, userId }) {
  const [salvando, setSalvando] = useState(false);
  const [compartilhado, setCompartilhado] = useState(false);

  const handleCompartilhar = async () => {
    if (salvando) return;
    setSalvando(true);
    try {
      const payload = { texto: nota };
      if (userId) payload.user_id = userId;
      if (desafioAtivo) {
        const { getDiaAtual } = await import('../../utils/desafios');
        const { diaAtual } = getDiaAtual(desafioAtivo.data_inicio, desafioAtivo.duracao);
        payload.desafio_id = desafioAtivo.desafio_id;
        payload.desafio_nome = desafioAtivo.desafio_nome;
        payload.desafio_dia = diaAtual;
        payload.prompt = desafioAtivo.prompts?.[`prompt_dia_${diaAtual}`] || prompt || null;
      } else if (prompt) {
        payload.prompt = prompt;
      }
      await supabase.from('reflexoes_anonimas').insert([payload]);
      if (window.fbq) window.fbq('trackCustom', 'ReflexaoCompartilhada');
      setCompartilhado(true);
      setTimeout(() => onFechar(true), 2000);
    } catch {
      onFechar(false);
    } finally {
      setSalvando(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target !== e.currentTarget) return;
    if (desafioAtivo) return; // no desafio, compartilhar é obrigatório
    onFechar(false);
  };

  return (
    <div className="modal-compartilhar-backdrop" onClick={handleBackdropClick}>
      <div className="modal-compartilhar-card">
        {compartilhado ? (
          <div className="modal-compartilhar-sucesso">
            <p className="modal-compartilhar-sucesso-texto">
              Você postou sua gratidão de hoje.
            </p>
          </div>
        ) : (
          <>
            <div className="modal-compartilhar-icone">
              <IconShare />
            </div>
            <h3 className="modal-compartilhar-titulo">Compartilhar com a comunidade?</h3>
            <p className="modal-compartilhar-descricao">
              Sua reflexão pode tocar alguém que está passando por algo parecido. Será publicada de forma totalmente anônima.
            </p>
            <div className="modal-compartilhar-acoes">
              <button
                className="btn btn-primary"
                style={{ width: '100%' }}
                onClick={handleCompartilhar}
                disabled={salvando}
              >
                {salvando ? 'Compartilhando...' : 'Compartilhar anonimamente'}
              </button>
              {!desafioAtivo && (
                <button
                  className="btn btn-ghost"
                  style={{ width: '100%', marginTop: 8 }}
                  onClick={() => onFechar(false)}
                  disabled={salvando}
                >
                  Guardar só pra mim
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
